import { render, staticRenderFns } from "./TabServicos.vue?vue&type=template&id=6d818be0&scoped=true&"
import script from "./TabServicos.vue?vue&type=script&lang=js&"
export * from "./TabServicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d818be0",
  null
  
)

export default component.exports